export const CORE_SEAT = 'CORE_SEAT';
export const SALES_SEAT = 'SALES_SEAT';
export const SERVICE_SEAT = 'SERVICE_SEAT';
export const CONTACTS = 'CONTACTS';
export const EMAIL_SENDS = 'EMAIL_SENDS';